<template>
  <div style="margin-top: -36px; ">
    <faq-question
      v-for="(question, index) in questions"
      v-bind:key="index"
      :tabIndex="index+1"
      :question="question.question"
      :answer="question.answer" />

    <p>Any other questions? Email us at <a tabindex="50" href="mailto:candidates@rarerecruitment.co.uk">candidates@rarerecruitment.co.uk</a>.</p>
  </div>
</template>

<script>

import RareLegalFaqQuestionComponent from './RareLegalFaqQuestionComponent';

export default {
  name: 'RareLegalFAQ',
  components: {
    'faq-question': RareLegalFaqQuestionComponent,
  },
  data() {
    return {
      questions: [
        {
          question: 'Can I join Rare if I\'m with Aspiring Solicitors/Powerful Media/SEO/Windsor Fellowship or similar?',
          answer: 'Yes. There are a number of organisations active in this area. They differ in their approach and what they offer. You can be a Rare candidate and a member of the above organisations, or any similar one.',
        },
        {
          question: 'If I get rejected by Rare, can I apply again?',
          answer: 'Yes. People get rejected for a number of reasons. Sometimes it\'s because we don\'t have opportunities to suit a candidate, sometimes it\'s because candidates need more development (i.e. more work experience). We add clients all the time. If something in your application has changed, or we have a new opportunity, we encourage you to apply again.',
        },
        {
          question: 'I\'m in my first year; what can you do for me?',
          answer: 'If you\'re in your first year, we provide expert career advice and introduce you to some of the best companies in the world. We run Rare Foundations programmes in banking, consulting, and law, hosted by our clients, that are specifically for first years.',
        },
        {
          question: 'I\'m an international student, can you help me?',
          answer: 'Yes. Some of our clients ask for EU applicants and some are open to international students. Apply online and we\'ll inform you of the opportunities available to you.',
        },
        {
          question: 'I\'m a Masters student. Can you help me?',
          answer: 'Yes. We help undergraduate and postgraduate students.',
        },
        {
          question: 'How do I know if my grades are good enough?',
          answer: 'We have no minimum grade requirements – we look at every application to Rare in its full social, educational and personal context. We’re elite – we look for outstanding people – but not elitist - we have people from over 100 universities on our books.',
        },
        {
          question: 'Can I work for Rare?',
          answer: 'Maybe! Many of our staff originally came to Rare as candidates. We\'re pretty picky about who we choose to join our team, but if you\'re interested in working for Rare, check out the \'Work for Rare\' section of the site.',
        },
        {
          question: 'Is your service only for ethnic minority candidates?',
          answer: 'No. We help everybody, and specialise in helping ethnic minority candidates. We also place a particular emphasis on helping people from disadvantaged backgrounds.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  @media only screen and (max-width: 640px)  {
    p {
      font-size: 14px;
      line-height: 1.71;
    }
  }

  @media only screen and (min-width: 641px)  {
    p {
      margin-top: 40px;
      font-size: 18px;
      line-height: 1.78;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalFAQ.vue